import { Grid, Typography, TextField, Box, Divider } from "@mui/material";
import FormikAutocomplete from '../../shared/AutoCompelete'
const timeOption = ["1:00","2:00","3:00","4:00","5:00","6:00","7:00","8:00","9:00","10:00","11:00","12:00"]
const dayOption = ["AM", "PM"]
const BankLogo = ({ formik, setTouched, createNew }) => {

  const handleChange = (e) => {
    setTouched(true);
    formik.handleChange(e);
  };
  return (
    <Grid
      container
      direction="column"
      rowSpacing="16px"
      justifyContent="flex-start"
      sx={{
        background: "#ffffff",
        borderRadius: "6px",
        border: "1px solid #E7E9EF",
        padding: "20px 30px 36px 30px",
        marginTop: "2px",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          gap: "12px",
        }}
      >
        <Typography
          sx={{
            color: "#050D2E",
            fontSize: "1.125rem",
            fontWeight: 550,
          }}
        >
          Bank Logo
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "12px",
            alignItems: "center",
          }}
        >
          <img
            src={formik.values.bankLogoUrl}
            style={{
              height: "75px",
              maxWidth: "200px",
              border: " 2px solid #D3D8E3",
              borderRadius: "4px",
              backgroundColor: "#f2f2f2",
            }}
            alt="bank-logo"
          ></img>
          <Grid item>
            {" "}
            <Typography
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: 550,
                lineHeight: "21px",
                marginBottom: "5px",
              }}
            >
              Logo URL
            </Typography>
            <TextField
              name="bankLogoUrl"
              value={formik.values.bankLogoUrl}
              onChange={handleChange}
              error={
                formik.touched.bankLogoUrl && Boolean(formik.errors.bankLogoUrl)
              }
              helperText={
                formik.touched.bankLogoUrl && formik.errors.bankLogoUrl
              }
              sx={{
                width: "360px",
                height: "36px",
                "& .MuiInputBase-root": { height: "36px" },
                "& .MuiOutlinedInput": { height: "36px" },
                ...(formik.errors.bankLogoUrl && { marginBottom: "10px" }),
              }}
              // disabled={!createNew}
            />
          </Grid>
        </Box>
      </Grid>
      <Divider sx={{ marginBlock: "20px" }} />
      <Grid item container xs={12} gap={2}>
        <Grid item>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Bank
          </Typography>
          <TextField
            name="bankName"
            value={formik.values.bankName}
            onChange={handleChange}
            error={formik.touched.bankName && Boolean(formik.errors.bankName)}
            helperText={formik.touched.bankName && formik.errors.bankName}
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.bankName && { marginBottom: "10px" }),
            }}
            disabled={!createNew}
          />
        </Grid>

        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            BIC Swift
          </Typography>
          <TextField
            name="bankBic"
            value={formik.values.bankBic}
            onChange={handleChange}
            error={formik.touched.bankBic && Boolean(formik.errors.bankBic)}
            helperText={formik.touched.bankBic && formik.errors.bankBic}
            sx={{
              width: "180px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.bankBic && { marginBottom: "10px" }),
            }}
            disabled={!createNew}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            LT Lettre
          </Typography>
          <TextField
            name="ltLetter"
            value={formik.values.ltLetter}
            onChange={handleChange}
            error={formik.touched.ltLetter && Boolean(formik.errors.ltLetter)}
            helperText={formik.touched.ltLetter && formik.errors.ltLetter}
            sx={{
              width: "80px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.ltLetter && { marginBottom: "10px" }),
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Station Number
          </Typography>
          <TextField
            name="stationNumber"
            value={formik.values.stationNumber}
            onChange={handleChange}
            error={
              formik.touched.stationNumber &&
              Boolean(formik.errors.stationNumber)
            }
            helperText={
              formik.touched.stationNumber && formik.errors.stationNumber
            }
            sx={{
              width: "180px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.stationNumber && { marginBottom: "10px" }),
            }}
          />
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "flex-start", gap: "16px" }}
      >
        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Website
          </Typography>
          <TextField
            name="website"
            value={formik.values.website}
            onChange={handleChange}
            error={formik.touched.website && Boolean(formik.errors.website)}
            helperText={formik.touched.website && formik.errors.website}
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.website && { marginBottom: "10px" }),
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              color: "#050D2E",
              fontSize: ".875rem",
              fontWeight: 550,
              lineHeight: "21px",
              marginBottom: "5px",
            }}
          >
            Email
          </Typography>
          <TextField
            name="email"
            value={formik.values.email}
            onChange={handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            sx={{
              width: "360px",
              height: "36px",
              "& .MuiInputBase-root": { height: "36px" },
              "& .MuiOutlinedInput": { height: "36px" },
              ...(formik.errors.email && { marginBottom: "10px" }),
            }}
          />
        </Box>

  <Box>
  <Typography 
  sx={{
    color: "#050D2E",
    fontSize: ".875rem",
    fontWeight: 550,
    lineHeight: "21px",
    marginBottom: "5px",
  }}
>
End Of Day Time
</Typography>

<Box display="flex"  gap={2}>
<FormikAutocomplete
 options={timeOption}
 getOptionLabel={(option) => (option ? option : '')}
 isOptionEqualToValue ={ (option, value) => option === value}
 width={100}
 value={formik.values.timeOption}
 name="timeOption"
 formik={formik}
 height={"36px"}
 setTouched={setTouched}
/>

<FormikAutocomplete
 options={dayOption}
 getOptionLabel={(option) => (option ? option : '')}
 isOptionEqualToValue ={ (option, value) => option === value}
 width={100}
 value={formik.values.dayOption}
 name="dayOption"
 formik={formik}
 height={"36px"}
 setTouched={setTouched}
/>
</Box>
</Box>

      </Grid>
    </Grid>
  );
};

export default BankLogo;
